import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';

import { ActionBar } from 'componentsV2/product/action-bar';

import type { PrintOrderItem } from '../../types';
import { usePrintOrderActionBar } from './hooks/use-print-order-action-bar';

export const PrintOrderActionBar = () => {
  const { items, isDeleting, handleCancel, openPreview } =
    usePrintOrderActionBar();

  if (!items.length) return null;

  return (
    <ActionBar<PrintOrderItem>
      type="resource"
      buttonLabel=""
      selectedProducts={items}
      handleClose={handleCancel}
      closeLoading={isDeleting}
      options={[
        {
          label: 'Review Cart',
          tooltipTitle: 'Review and send your print order',
          variant: 'contained',
          color: 'primary',
          endIcon: <ArrowForwardRoundedIcon />,
          onClick: openPreview
        }
      ]}
    />
  );
};
